import { Formik } from 'formik';
import React, { useMemo } from 'react';
import { Form } from 'react-bootstrap';

import { useProfileUpdate } from '../../../hooks';
import { AutoSave } from '../../BaseUI';
import { ImageFieldWithAvatar } from '../../FormFields';
import ProfileImageSchema from './ProfileImageSchema';

const ProfileImage = ({ userId, profileImage }) => {
  const initialState = useMemo(
    () => ({
      profileImage: profileImage || [],
    }),
    [profileImage]
  );

  const { saveProfile, showSave, saveStatus } = useProfileUpdate(userId);

  const handleSubmit = ({ profileImage }) => {
    if (typeof profileImage === 'string') return;
    const sanitizedParams = { picture: profileImage, withImage: true };
    saveProfile(sanitizedParams);
  };

  return (
    <Formik
      initialValues={initialState}
      onSubmit={handleSubmit}
      validationSchema={ProfileImageSchema}
    >
      {(formik) => (
        <Form noValidate onSubmit={formik.handleSubmit}>
          <AutoSave debounceMs={500} />
          {showSave && (
            <div
              className={`save-label-img ${
                saveStatus === 'Saved' || saveStatus === 'Saving' ? 'success' : 'failure'
              }`}
            >
              {saveStatus}
            </div>
          )}
          <div className="image-container">
            <ImageFieldWithAvatar name="profileImage" />
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default ProfileImage;
